import { NavLink } from "react-router-dom";
import { ExperienceAnalyticsSummary } from "../../types/Analytics";

interface ExperienceAnalyticsBlockProps {
  experience: ExperienceAnalyticsSummary;
  navigatable?: boolean;
}

export default function ExperienceAnalyticsBlock({
  experience,
  navigatable = true,
}: ExperienceAnalyticsBlockProps) {

  const getBody = () => {
    return (
      <>
      <h1 className="text-2xl">{experience.name}</h1>
      <h2 className="text-xl">Sessions</h2>
      <dl className="grid grid-cols-2 xl:grid-cols-3 gap-4">
        <div>
          <dt className="text-sm font-medium text-gray-300">Last hour</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast1Hour}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 24 hours</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast24Hours}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 7 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast7Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 30 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast30Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 60 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast60Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 90 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.streamingSessionsCountInLast90Days}
          </dd>
        </div>
      </dl>
      <hr className="my-4" />
      <h2 className="text-xl">Local recordings</h2>
      <dl className="grid grid-cols-2 xl:grid-cols-3 gap-4">
        <div>
          <dt className="text-sm font-medium text-gray-300">Last hour</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast1Hour}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 24 hours</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast24Hours}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 7 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast7Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 30 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast30Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 60 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast60Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 90 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {experience.localRecordingsCountInLast90Days}
          </dd>
        </div>
      </dl>
      </>
    )}

  if (!experience) {
    return <></>;
  }

  if (navigatable === true) {
    return (
      <NavLink to={`/analytics/experience/${experience.companyId}/${experience.experienceId}`} className="card p-5">
        {getBody()}
      </NavLink>
    );
  }

  return (
    <div className="card p-5">
      {getBody()}   
    </div>
  );
}
